import React from 'react';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/components/capstone/base';

const FallbackComponent = props => {
  const friendlyComponentName = props.schema.componentProperties.name
    .split('-')
    .join(' ');
  return (
    <Box px="13px" py="15px" justify="center">
      <Box justify="center" horizontal>
        <AttentionTriangleIcon height={16} width={16} color="secondaryLink" />
        <Text
          size="large"
          color="primaryText"
          fontWeight="bold"
          textAlign="center"
          inline
          pl="16px"
        >
          An error has occurred.
        </Text>
      </Box>
      <Text inline textAlign="center">
        We are unable to show data for{' '}
        <Text fontWeight="bold" inline>
          {friendlyComponentName}
        </Text>{' '}
        at this time.
      </Text>
      <Text textAlign="center">
        Please submit a ticket via the "Support" tab.
      </Text>
    </Box>
  );
};
export default FallbackComponent;
